import { t } from '@/lib/copy'
import { bandColorVar, bandLabelKey, chart, type ScoreBand } from '@/lib/tokens'
import { tServer } from '@/lib/copy'

/**
 * The health score dial. Thickness comes from chart.scoreDialThickness and the
 * arc colour from the score band, so it matches the iOS dial exactly.
 */
export function ScoreDial({
  score,
  band,
  size = 220,
}: {
  score: number
  band: ScoreBand
  size?: number
}) {
  const thickness = chart.scoreDialThickness
  const radius = (size - thickness) / 2
  const circumference = 2 * Math.PI * radius
  const swept = (Math.max(0, Math.min(100, score)) / 100) * circumference
  const bandLabel = tServer(bandLabelKey(band))

  return (
    <div className="score-dial" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        role="img"
        aria-label={t('a11y.scoreDial', { score, band: bandLabel })}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--color-scoreTrack)"
          strokeWidth={thickness}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={bandColorVar(band)}
          strokeWidth={thickness}
          strokeLinecap="round"
          strokeDasharray={`${swept} ${circumference - swept}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <span className="score-dial-value" aria-hidden="true">
        <span className="score-dial-number">{score}</span>
        <span className="score-dial-band">{bandLabel}</span>
      </span>
    </div>
  )
}
